export default __webpack_public_path__ + "static/media/user.a9d422b5.svg";